import { VideoData, Video } from "./data.types";

export const data: VideoData = {
  videos: [
      {
        _id:"6210befd9fc323d1ab58983e",
        url:"https://youtu.be/HE45jVN7XKM",
        channelLogo:"https://yt3.ggpht.com/ytc/AKedOLQg6gDZ9Z0wuMSRwtdl9e0SiI0mklMDFXeGjBktXg=s176-c-k-c0x00ffffff-no-rj",
        channelName:"ATHLEAN-X™","description":"The perfect push workout is a component of a push, pull, legs workout split which is one of the most common training splits for building muscle and strength. In this video, I'm continuing the perfect workout series and bringing you the perfect push workout to build a bigger chest, shoulders, and triceps. Not only am I going to provide the exercises, but I'm breaking down all the sets and reps to make sure you don't miss out on any muscle gains.",
        statistics:"62,190 views • 14 May 2021",
        thumbnail:"https://i.ytimg.com/vi/HE45jVN7XKM/hqdefault.jpg",
        title:"The PERFECT Push Workout (PUSH | PULL | LEGS)"
    },
    

      {

     _id:"6210ca919278f1903306f153",
      url:"https://youtu.be/IOl42YpK_Es",
      thumbnail:"https://i.ytimg.com/vi/IOl42YpK_Es/hqdefault.jpg",
      title:"The PERFECT Pull Workout (PUSH | PULL | LEGS)",
      statistics:"62,190 views • 14 May 2021",
      description:"The push, pull, legs workout split is one of the most often used training splits for building muscle and strength. In this video, I'm going to deliver the next in the perfect workout series to give you the best pull workout for building a bigger back, traps and biceps. As always, I'm breaking down all sets and reps for each and every exercise to make sure you get the muscle gains you are looking for.",
      channelName:"ATHLEAN-X™",
      channelLogo:"https://yt3.ggpht.com/ytc/AKedOLQg6gDZ9Z0wuMSRwtdl9e0SiI0mklMDFXeGjBktXg=s88-c-k-c0x00ffffff-no-rj"
    },

      {
        _id:"6210cfad9278f1903306f158",
      url:"https://youtu.be/X6H4l9R3DnY",
      thumbnail:"https://i.ytimg.com/vi/X6H4l9R3DnY/hqdefault.jpg",
      title:"The PERFECT LEG Workout (PUSH | PULL | LEGS)",
      statistics:"62,190 views • 14 May 2021",
      description:"The perfect leg workout that fits into a push, pull, legs split is something I want to break down for you in this video. Unlike a stand alone leg workout, this has to relate to what is happening in the other two workouts of the split and make sure it's complimenting the work that is being done on the alternate training days.",
      channelName:"ATHLEAN-X™",
      channelLogo:"https://yt3.ggpht.com/ytc/AKedOLQg6gDZ9Z0wuMSRwtdl9e0SiI0mklMDFXeGjBktXg=s88-c-k-c0x00ffffff-no-rj"
    },

      {_id:"6210d3049278f1903306f15a",
      "url":"https://youtu.be/vc1E5CfRfos",
      "thumbnail":"https://i.ytimg.com/vi/vc1E5CfRfos/hqdefault.jpg",
      "title":"The PERFECT Home Workout (Sets and Reps Included)",
      "statistics":"62,190 views • 14 May 2021",
      "description":"Home workouts can be a lifesaver, especially in times when you cannot get to the gym. In this video, I'm going to give you a complete home workout routine with all sets and reps included to help you to build muscle regardless of whether or not you ever step foot in a gym. The key to the effectiveness of this perfect home workout is that it pairs exercises together in a way that allows you to train to greater overload ",
      "channelName":"ATHLEAN-X™",
      "channelLogo":"https://yt3.ggpht.com/ytc/AKedOLQg6gDZ9Z0wuMSRwtdl9e0SiI0mklMDFXeGjBktXg=s88-c-k-c0x00ffffff-no-rj"
    },
      {_id:"6210d5109278f1903306f15b",
      "url":"https://youtu.be/1OF3q6MHie8",
      "thumbnail":"https://i.ytimg.com/vi/1OF3q6MHie8/hqdefault.jpg",
      "title":"6 Pack Abs Workout (BURNS FAT TOO!)",
      "statistics":"62,190 views • 14 May 2021",
      "description":"Many people dream of having six-pack abs, but it takes more than hundreds of crunches a day to reach the goal.First and foremost, abs are made in the kitchen. Once you've established the proper diet, you have to focus on the muscles surrounding your abs—the core.The core is the body's center of power. It contains the muscles that lie deep within the torso and stabilize your body, whether it's stationary or dynamic movement. Balance and stabilization workouts help define the abdominal muscle groups, which results in the defined stomach many desire.",
      "channelName":"ATHLEAN-X™",
      "channelLogo":"https://yt3.ggpht.com/ytc/AKedOLQg6gDZ9Z0wuMSRwtdl9e0SiI0mklMDFXeGjBktXg=s88-c-k-c0x00ffffff-no-rj" 
    },
      {_id:"6210d6bb9278f1903306f15c",
      "url":"https://youtu.be/jLkLH_RQRuQ",
      "thumbnail":"https://i.ytimg.com/vi/jLkLH_RQRuQ/hqdefault.jpg",
      "title":"How to Lose Fat (EAT CARBS!)",
      "statistics":"62,190 views • 14 May 2021",
      "description":"The key to fat burning is that you need to be in a hypocaloric state. Due to the tendency we have of overeating carbs there is some logic to the fact that by eliminating them from our diets we will consume fewer calories overall. That said, the replacement of the carbs has to come from somewhere. In the case of keto diets it comes in the form of fats and proteins, mostly from dietary fats. ",
      "channelName":"ATHLEAN-X™",
      "channelLogo":"https://yt3.ggpht.com/ytc/AKedOLQg6gDZ9Z0wuMSRwtdl9e0SiI0mklMDFXeGjBktXg=s88-c-k-c0x00ffffff-no-rj"
    },
  ],
};
export const defaultVideoType : Video = {
    _id: "1234",
    url: "bad url",
    thumbnail: "bad thumbnail",
    title: "bad title",
    statistics: "bad statistics",
    description: "bad description",
    channelName: "bad channelName",
    channelLogo: "bad channelLogo"
  } 